<template>
    <div class="invoice">
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="display: flex;background: #fff;">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-top">
                        <div class="right-title">申请发票</div>
                        <div class="manage-order-a" style="padding: 30px 0 30px 30px;height: auto;">
                            <div class="input-box">
                                <span>订单号：</span>
                                <input v-model="OrderNo" type="text">
                            </div>
                            <div class="input-box">
                                <span>结算来源：</span>
                                <div class="select-box">
                                    <select v-model="settlementType">
                                        <option :value="0">单结</option>
                                        <option :value="1">周期结</option>
                                    </select>
                                </div>
                            </div>
                            <div class="input-box date-time">
                                <span v-if="settlementType==0">离店时间：</span>
                                <span v-if="settlementType==1">账单生成时间：</span>
                                <input type="text" class="date-time" v-model="Start" @click="calendar.show=true" data-type="time" readonly>
                                -
                                <input type="text" class="date-time" v-model="End" @click="calendar.show=true" data-type="time" readonly>
                                <DatePicker @select="calendar.select" v-show="calendar.show" :start="calendar.start"
                                            :beginDate="calendar.begin" :last="calendar.last" :endDate="calendar.end" >
                                </DatePicker>
                            </div>
                            
                            <div class="btn-box-a">
                                <div class="btn-screening" @click="getInvoiceList">搜索</div>
                            </div>
                        </div>
                        </div>
                        <div class="manage-invoice">
                            <div class="invoice">
                                <span class="total">可开票总额 ：<span>{{invoiceInfo ? invoiceInfo.InvoicedAmount : 0}}</span></span>
                                <span class="total">
                                    <div class="get-invoice" @click="allSaveInvoice">全部申请</div>
                                </span>
                                 <span class="total">
                                    <Loading :isLoading="allInvoiceLoading"></Loading>
                                </span>
                                <span class="total">已选开票金额 ：<span>{{selectAmount}}</span></span>
                                <input type="hidden" :value="selectNo.join()">
                            </div>
                            <div class="get-invoice" @click="goSaveInvoice">选择申请</div>
                        </div>

                        <!--周期结-->
                        <div class="invoice-table-box"  v-if="settlementType == 1">
                            <table class="invoice-table">
                                <thead>
                                <tr>
                                    <td width="55px"><span @click="boo=true" style="cursor: pointer;float: left;padding-left: 10px;color: #1270f8;">全选</span>账单号</td>
                                    <td width="55px">账单金额</td>
                                    <td width="55px">可开票金额</td>
                                    <td width="55px">生成时间</td>
                                    <td width="55px">结算类型</td>
                                    <td width="55px">最晚开票日期</td>
                                    <td width="55px">账单详情</td>
                                </tr>
                                </thead>
                                <template >
                                    <tbody v-if="!isLoading&&total !=0 &&invoiceInfo">
                                        <tr v-for="item, index in invoiceInfo.InvoiceBills" :key="item.NO">
                                            <td width="55px"><input v-model="selectList" type="checkbox" :value="item">{{item.BillID}}</td>
                                            <td width="55px">{{item.Received}}</td>
                                            <td width="55px">{{item.Received}}</td>
                                            <td width="55px">{{item.CreateOnStr}}</td>
                                            <td width="55px">
                                                <span v-if="item.IsSettled">已结清</span>
                                                <span v-if="!item.IsSettled">未结清</span>
                                            </td>
                                            <td width="55px">{{item.LatestInvoiceTimeStr}}</td>
                                            <td class="view" width="55px"  @click="routetokPage('/orderDetails')">查看详情</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td align="center" style="vertical-align: middle" colspan="7">
                                                <div v-if="isLoading">
                                                    <Loading :isLoading="isLoading"></Loading>
                                                </div>
                                                <div v-else>{{noneDataMsg}}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </table>
                            <div class="Page">
                                <span @click="handlePrev" class="PageBtn">上一页</span>
                                <span class="PageNumber">第{{Page}}页/共{{allPage}}页</span>
                                <span @click="handleNext" class="PageBtn">下一页</span>
                           </div>
                        </div>

                        <!--单结-->
                        <div class="invoice-table-box" v-if="settlementType == 0">
                            <table class="invoice-table">
                                <thead>
                                <tr>
                                    <td width="150px"><span @click="boo=true" style="cursor: pointer;float: left;padding-left: 10px;color: #0075ff;">全选</span>订单号</td>
                                    <td width="150px">酒店名</td>
                                    <td width="100px">入住时间<br/>离店时间</td>
                                    <td width="80px">订单金额</td>
                                    <td width="100px">预订时间</td>
                                    <td width="80px">结算类型<br/>结算状态</td>
                                    <!-- <td width="80px">结算状态</td> -->
                                    <td width="110px">最晚开票时间</td>
                                    <td width="100px">订单详情</td>
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading&&total !=0 && invoiceInfo">
                                <tr v-for="item, index in invoiceInfo.InvoiceOrders" :key="item.NO">
                                    <td width="100px"><input v-model="selectList" type="checkbox" :value="item">{{item.OrderNO}}</td>
                                    <td width="200px">{{item.HotelName}}</td>
                                    <td width="120px">{{item.CheckInStr}}<br/>{{item.CheckOutStr}}</td>
                                    <td width="100px">{{item.TotalAmount}}{{item.Currency}}</td>
                                    <td width="100px">{{item.BookingOnStr}}</td>
                                    <td width="80px">{{item.SettlementTypeName}}<br/>
                                        <span v-if="item.IsSettled">已结清</span>
                                        <span v-if="!item.IsSettled">未结清</span>
                                    </td>
                                    <!-- <td width="80px">
                                        <span v-if="item.IsSettled">已结清</span>
                                        <span v-if="!item.IsSettled">未结清</span>
                                    </td> -->
                                    <td width="100px">{{item.LatestInvoiceTimeStr}}</td>
                                    <td width="100px" class="view" @click="goDetail(item)">查看详情</td>
                                </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td align="center" style="vertical-align: middle" colspan="8">
                                            <div v-if="isLoading">
                                                <Loading :isLoading="isLoading"></Loading>
                                            </div>
                                            <div v-else>{{noneDataMsg}}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="Page">
                                <span @click="handlePrev" class="PageBtn">上一页</span>
                                <span class="PageNumber">第{{Page}}页/共{{allPage}}页</span>
                                <span @click="handleNext" class="PageBtn">下一页</span>
                           </div>
                            
                            <!-- <div class="table-no-more" style="width: 100%" v-if="!isLoading&&total ==0">
                                
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from './../../common/cmpnt/menu/Menu'
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲


    export default {
        name: "invoice",
        components: {
            Menu,
            DatePicker,
            Loading,
        },
        data() {
            return {
                isLoading: false,
                allInvoiceLoading:false,
                settlementType: 0,
                invoiceInfo: null,
                selectList: [],
                total: 0,
                Start: this.getDate(-90),
                End: this.getDate(0),
                OrderNo: null,
                Page: 1,
                PageSize: 8,
                allPage: '',
                calendar: {
                    show: false,
                    start: this.getDate(-180),
                    last: this.getDate(0),
                    begin: this.getDate(-90),
                    end: this.getDate(0),
                    select: (begin, end) => {
                        if (!begin) {
                            this.calendar.show = false;
                            this.calendar.begin = this.Start;
                            this.calendar.end = this.End;
                            return;
                        }

                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.Start = begin;
                        this.End = end;
                        this.$nextTick(function () {
                            this.calendar.show = false;
                            // this.changeFilter();
                        });
                    }
                },
                noneDataMsg:''
            }
        },
        watch:{
            settlementType(){
                this.noneDataMsg=''
            }
        },
        mounted() {
            document.title = '发票管理'
            this.getInvoiceList()
        },
        computed: {
            selectAmount () {
                let price = 0
                if (this.settlementType == 0) {
                    this.selectList.forEach(item => {
                        price += item.TotalAmount
                    })
                }
                if (this.settlementType == 1) {
                    this.selectList.forEach(item => {
                        price += item.Received
                    })
                }
                return price
            },
            selectNo () {
                let no = []
                if (this.settlementType == 0) {
                    this.selectList.forEach(item => {
                        no.push(item.OrderNO)
                    })
                }
                if (this.settlementType == 1) {
                    this.selectList.forEach(item => {
                        no.push(item.BillID)
                    })
                }
                return no
            },
            boo:{
                get(){
                    // return this.selectList.length == this.invoiceInfo.InvoiceOrders.length
                },


                set(val){
                    var that = this
                    var arr = [];
                    var newArr = [];
                    if(val){
                        that.invoiceInfo.InvoiceOrders.map(obj=>{
                            arr.push(obj)
                        })
                        var newArr = that.selectList.concat(arr)
                        const uniqueArr = newArr.filter((item,index,self)=>{
                            const i = self.findIndex(t=>t.OrderNO===item.OrderNO);
                            return i===index
                        })
                        that.selectList = uniqueArr
                    }
                }
            }
        },
        methods: {
          


            handlePrev(){
                if(this.Page>1){
                    this.Page--;
                    this.boo = false
                    this.getInvoiceList()
                }else {
                     this.error({title:'提示',content:'当前为最前页'});
                }
            },


            handleNext(){
                if(this.Page<this.allPage){
                    this.Page++;
                    this.boo = false
                    this.getInvoiceList()
                }else {
                     this.error({title:'提示',content:'当前为最后页'});
                }
            },

            
            getInvoiceList () {
                let that = this
                // this.selectList = []
                let param = {
                    SettlementTypeId: this.settlementType,
                    TimeStart: this.Start,
                    TimeEnd: this.End,
                    OrderNo: this.OrderNo,
                    Page: this.Page,
                    PageSize: this.PageSize
                }
                that.isLoading = true
                that.postRequest({
                    url:that.Api.InvoiceSearch,
                    params:param
                }).then(res => {
                    that.isLoading = false
                    if(res.IsSuccess){
                        that.invoiceInfo = res.Result
                        that.total = res.Result.Total
                        that.allPage = Math.ceil(res.Result.Total/that.PageSize)
                        if(!that.total){
                            this.Page = 1,
                            that.noneDataMsg='暂无数据...'
                        }else{
                            that.noneDataMsg=''
                        }
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }       
                        })
                    }else{
                        this.error({title:'提示',content:res.Msg||'不能预订'});
                    }
                });
            },
            goSaveInvoice () {
                if (this.selectList.length == 0) {
                    this.error({title:'提示',content:'至少选择一条数据'});
                } else {
                    this.$router.push({path: 'information', query:{ no: this.selectNo.join(), amount: this.selectAmount, type: this.settlementType }})
                }
            },
            allSaveInvoice () {
                let that = this
                if(that.invoiceInfo&&that.invoiceInfo.InvoicedAmount>0){
                    let param = {
                        SettlementTypeId: this.settlementType,
                        TimeStart: this.Start,
                        TimeEnd: this.End,
                        OrderNo: this.OrderNo,
                        Page: 1,
                        PageSize: this.total
                    }
                    that.allInvoiceLoading = true
                    that.postRequest({
                        url:that.Api.InvoiceSearch,
                        params:param
                    }).then(res => {
                        that.allInvoiceLoading = false
                        if(res.IsSuccess){
                            var arr = res.Result.InvoiceOrders
                            let no = []
                            if (this.settlementType == 0) {
                                arr.forEach(item => {
                                    no.push(item.OrderNO)
                                })
                            }
                            if (this.settlementType == 1) {
                                arr.forEach(item => {
                                    no.push(item.BillID)
                                })
                            }
                            this.$router.push({path: 'information', query:{ no: no.join(), amount: res.Result.InvoicedAmount, type: this.settlementType }})
                        }else{
                            this.error({title:'提示',content:'数据拉取失败，无法使用该方式开票'});
                        }
                    });

                }else{
                    this.error({title:'提示',content:'可开票金额为 0 ，无法为您开票'});
                }
            },
            goDetail (item) {
                let routeData = this.$router.resolve({ path: '/orderDetails/'+item.OrderNO});
                window.open(routeData.href, '_blank');
            }
        }
    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/invoice/invoice.vue